import { configureStore } from "@reduxjs/toolkit"
import createSagaMiddleware from "redux-saga"
import { createBrowserRouter, createRoutesFromElements } from "react-router-dom"
import sagas from "./sagas"
import reducers from "./reducers"
import { createQueryStringStoreMiddleware } from "./new/redux-middlewares/query-string"
import getRoutes from "./routes"

export default function configureApp(initialState) {
  // Router
  const routes = createRoutesFromElements(getRoutes())
  const router = createBrowserRouter(routes)

  // Saga
  const sagaMiddleware = createSagaMiddleware()
  sagaMiddleware.setContext({ router })

  const store = configureStore({
    reducer: reducers,
    preloadedState: initialState,
    devTools: process.env.NODE_ENV !== "production",
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: false,
        serializableCheck: false,
        immutableCheck: { warnAfter: 128 },
      }).concat(
        sagaMiddleware,
        createQueryStringStoreMiddleware(router.navigate),
      ),
  })

  sagas.forEach(saga => sagaMiddleware.run(saga))

  return { store, router }
}
